import ImageTool from './tools/image';

export default {
    image: new ImageTool(),
};



// WEBPACK FOOTER //
// ./~/@bigcommerce/stencil-utils/src/tools.js